import {MergeabilityFailureIcon} from '@github-ui/custom-icons/MergeabilityFailureIcon'
import {ForYouItem} from '../shared/ForYouItem'
import {useMergeabilityData} from './use-mergeability-data'
import {hasUnhandledMergeBlocker} from './merge-blocked-visibility'
import {OverviewMergeControl} from './shared/OverviewMergeControl'
import {Button} from '@primer/react'
import {useGoToMergeBox} from '../../mergebox/use-go-to-mergebox'
import {usePullRequestAnalytics} from '../../../../hooks/use-pull-request-analytics'

export function shouldShowMergeBlocked(data: ReturnType<typeof useMergeabilityData>) {
  const blockedSection = data?.blockedSection

  return (
    !!data &&
    !data.isClosedOrMerged &&
    !data.mergeBoxPullRequest.isDraft &&
    !!blockedSection &&
    blockedSection.sectionStatus !== 'PASSED' &&
    hasUnhandledMergeBlocker(blockedSection.failingConditionsAndRules)
  )
}

// Catch-all "Needs attention" item shown to the author when the merge is blocked
// for a reason not covered by a more specific action item (e.g. a failing
// ruleset rule, an unmet merge condition, or an authorization policy).
export function MergeBlocked() {
  const data = useMergeabilityData()
  const goToMergeBox = useGoToMergeBox()
  const {sendPullRequestAnalyticsEvent} = usePullRequestAnalytics()

  if (!data || !shouldShowMergeBlocked(data)) return null

  return (
    <ForYouItem
      itemId="merge-blocked"
      visual={{kind: 'icon', icon: MergeabilityFailureIcon, tone: 'danger', glyphSize: 12}}
      title="Merge is blocked"
      actions={[
        {
          id: 'view-merge-status',
          content: data.stackSection?.isStacked ? null : (
            <Button
              size="small"
              variant="default"
              onClick={event => {
                sendPullRequestAnalyticsEvent('overview.for_you_item_action', 'OVERVIEW_FOR_YOU_ITEM', {
                  item_name: 'merge-blocked',
                  action_name: 'view_merge_status',
                })
                goToMergeBox(event.currentTarget)
              }}
            >
              View merge status
            </Button>
          ),
        },
        {
          id: 'merge-control',
          content: <OverviewMergeControl data={data} fallbackAction="view-status" itemName="merge-blocked" />,
        },
      ]}
    />
  )
}
